import { useEffect, useState } from "react";
import { X, MessageCircle, Rocket } from "lucide-react";
import { COMPANY } from "@/data/content";

const KEY = "orina_popup_seen_v1";

export default function WelcomePopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const seen = sessionStorage.getItem(KEY);
    if (seen) return;
    // Desktop: open after 6 seconds. Phones: open only once the visitor has
    // scrolled halfway down the page, so it never covers the page on arrival.
    if (window.matchMedia("(min-width: 1024px)").matches) {
      const t = setTimeout(() => setOpen(true), 6000);
      return () => clearTimeout(t);
    }
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max >= 0.5) {
        setOpen(true);
        window.removeEventListener("scroll", onScroll);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => {
    setOpen(false);
    sessionStorage.setItem(KEY, "1");
  };

  if (!open) return null;

  const num = COMPANY.whatsapp.replace(/\D/g, "");
  const text = encodeURIComponent(COMPANY.whatsappMessage);

  return (
    <div
      data-testid="welcome-popup"
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm"
      onClick={close}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-md border-2 border-black bg-white shadow-brutal-lg"
      >
        <button
          onClick={close}
          aria-label="Close popup"
          data-testid="popup-close"
          className="absolute right-3 top-3 border-2 border-black bg-white p-1.5 hover:bg-[#FFD700]"
        >
          <X size={16} />
        </button>

        <div className="border-b-2 border-black bg-[#FFD700] p-6 text-center md:p-8">
          <div className="mx-auto flex h-14 w-14 items-center justify-center border-2 border-black bg-black text-[#FFD700]">
            <Rocket size={26} />
          </div>
          <h3 className="display mt-4 text-2xl font-black leading-tight md:text-3xl">
            Start Selling Online Today 🚀
          </h3>
          <p className="mt-3 text-sm text-black/80 md:text-base">
            Connect with Orina Enterprise for seller onboarding & marketplace growth — across Amazon, Flipkart, Meesho & more.
          </p>
        </div>

        <div className="space-y-3 p-6 md:p-8">
          <a
            data-testid="popup-whatsapp"
            href={`https://wa.me/${num}?text=${text}`}
            target="_blank"
            rel="noreferrer"
            className="btn-brutal flex w-full items-center justify-center"
            style={{ background: "#25D366", color: "#fff", borderColor: "#000" }}
          >
            <MessageCircle size={16} /> Chat on WhatsApp
          </a>
          <a
            href="/contact/?type=audit"
            data-testid="popup-audit"
            className="btn-brutal secondary flex w-full items-center justify-center"
            onClick={close}
          >
            Get Free Account Audit
          </a>
          <button
            onClick={close}
            className="block w-full pt-1 text-center text-xs font-bold uppercase tracking-widest text-black/50 hover:text-black"
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}
